




















































import { Component, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../Pi/types'
import ButtonView from '../../../../../../components/NodeButtonsView/ButtonView.vue'
import CustomEditor from '../../../../../Editor/CustomEditor'
import { RandomizerNode } from '../../index'
import PercentChanger from './PercentChanger.vue'

@Component({
  components: {
    ButtonView,
    PercentChanger,
  }
})
export default class RandomizerSidebar extends UseFields {
  @Prop() node!: RandomizerNode

  @Prop() editor!: CustomEditor

  get buttons(): any {
    return this.node.data.buttons
  }

  setRandom(arg: FieldData): FieldData {
    arg.setter = (val) => {
      this.node.switchRandom(val)
    }
    return arg
  }
}
